
class HeaderDrawer extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.section-header');
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onBodyClickEvent = this.onBodyClick.bind(this);
    this.onKeyUpEvent = this.onKeyUp.bind(this);

    this.details = this.querySelector('[ref="details"]') || this.querySelector('details');
    this.menuDrawer = this.querySelector('[ref="menuDrawer"]');
  }

  connectedCallback() {
    const summaryEl = this.querySelector('summary');
    if (summaryEl) {
      summaryEl.addEventListener('click', this.onSummaryClick.bind(this));
    }

    // Botón cerrar principal
    const closeButtons = this.querySelectorAll('.menu-drawer__close-button');
    closeButtons.forEach(btn => {
      btn.addEventListener('click', this.close.bind(this));
    });

    // Botones back de submenús
    const backButtons = this.querySelectorAll('.menu-drawer__back-button');
    backButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const submenu = btn.closest('.menu-drawer__submenu');
        if (submenu) {
          const parentDetails = submenu.closest('details');
          if (parentDetails) parentDetails.removeAttribute('open');
        }
      });
    });

    // Backdrop
    const backdrop = this.querySelector('.menu-drawer__backdrop');
    if (backdrop) {
      backdrop.addEventListener('click', this.close.bind(this));
    }
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.details.classList.contains('menu-open')) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    document.documentElement.style.setProperty('overflow', 'hidden');
    document.body.style.setProperty('overflow', 'hidden');

    this.details.setAttribute('open', true);
    this.details.classList.add('menu-open');

    // BHL: Forzar drawer desde la derecha
    const drawer = this.querySelector('.menu-drawer');
    if (drawer) {
      drawer.style.setProperty('left', 'auto', 'important');
      drawer.style.setProperty('right', '0', 'important');
      drawer.style.setProperty('transform', 'translate(0)', 'important');
      drawer.style.setProperty('visibility', 'visible', 'important');
    }

// BHL: Forzar X visible
const closeBtn = this.querySelector('.menu-drawer__close-button');
if (closeBtn) {
  const headerTop = document.querySelector('#header-component, .header')?.getBoundingClientRect().top || 0;
  closeBtn.style.setProperty('position', 'fixed', 'important');
  closeBtn.style.setProperty('top', (headerTop + 12) + 'px', 'important');
  closeBtn.style.setProperty('right', '12px', 'important');
  closeBtn.style.setProperty('left', 'auto', 'important');
  closeBtn.style.setProperty('z-index', '99999', 'important');
}

    document.addEventListener('keyup', this.onKeyUpEvent);
    document.addEventListener('click', this.onBodyClickEvent);
  }


  close() {
    // Liberar scroll
    document.documentElement.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow');

    this.details.classList.remove('menu-open');

    // Cerrar todos los submenús abiertos
    this.querySelectorAll('details[open]').forEach(d => {
      d.removeAttribute('open');
    });

    // Esperar animación antes de quitar open del details principal
    setTimeout(() => {
      this.details.removeAttribute('open');
    }, 300);

    document.removeEventListener('keyup', this.onKeyUpEvent);
    document.removeEventListener('click', this.onBodyClickEvent);
  }

  onBodyClick(event) {
    if (!this.contains(event.target)) {
      this.close();
    }
  }

  onKeyUp(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }
}

customElements.define('header-drawer', HeaderDrawer);

